<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="header-container">
    <v-row v-if="getCurrentUserIsAbleToWrite('userRole')" class="add-controller">
      <v-btn
        id="user-role-add"
        dense
        small
        class="ctp-btn my-0"
        dark
        @click="handleAdd"
      >
        <v-icon x-small>mdi-plus</v-icon>
        {{ $t('access.user_role.buttons.add_user_role') }}
      </v-btn>
    </v-row>
    <div class="paginator">
      <Paginator
        :currentIndex="getUserRolesNavigationConfiguration.start"
        :elementsPerPage="getUserRolesNavigationConfiguration.elementsPerPage"
        :undeterminate="false"
        :numberOfElements="getTotalUserRoles"
        :disableNextPage="getUserRolesNavigationConfiguration.isLastElementsPage
          || getUserRolesListState.loading.userRolesList"
        :alternateStyle="true"
        class="mt-5 mx-0"
        @page-change="pageNavigationHandler"
        @go-to-page="navigateToPage"
      />
    </div>
    <Modal
      :display="getAddition"
      @cancel="handleCancel"
    />
  </div>
</template>
<script setup lang="ts">
import _ from 'lodash';
import Paginator from '@/components/common/Paginator/Paginator.vue';
import { IRolePermissions } from '@/store/modules/userRoles/types';
import { computed, watch } from 'vue';
import useStore from '@/utils/store/common';
import Modal from './components/Modal/Modal.vue';

const store = useStore();

const getUserRolesNavigationConfiguration = computed(() => store.getters['userRoles/getUserRolesNavigationConfiguration']);

const getUserRolesListState = computed(() => store.getters['userRoles/getUserRolesListState']);

const getAddition = computed(() => store.getters['userRoles/getAddition']);

const getTotalUserRoles = computed(() => store.getters['userRoles/getTotalUserRoles']);

let role: IRolePermissions | undefined;

function pageNavigationHandler(
  direction: 'forward' | 'backward'
): void {
  store.dispatch('userRoles/userRolesListNavigation', {
    direction
  });
}

function getCurrentUserIsAbleToWrite(featureName: string) {
  return featureName ? store.getters['permissions/getCurrentUserIsAbleTo']('write', featureName) : false;
}

function handleAdd() {
  store.dispatch('userRoles/setEdition', false);
  store.dispatch('userRoles/setAddition', true);
  role = _.cloneDeep(store.getters['userRoles/getCurrentUserRole']);

  store.dispatch('userRoles/resetPermissionsOfRole');
}

function handleCancel() {
  if (role && role.id) {
    store.dispatch('userRoles/fetchPermissionsOfRole', role.id);
  }
  store.dispatch('userRoles/setAddition', false);
}

function navigateToPage(page: number) {
  const current = getUserRolesNavigationConfiguration.value;
  const next = {
    ...current,
    start: page * current.elementsPerPage - current.elementsPerPage
  };
  store.dispatch('userRoles/updateNavigation', next);
}

watch(
  () => getUserRolesNavigationConfiguration.value.start,
  async () => {
    await store.dispatch('userRoles/fetchPermissionsRoles', getUserRolesNavigationConfiguration.value);
  },
  {
    immediate: true
  }
);

</script>
<style lang="scss" scoped>
@import './styles/header.scss';
</style>
